var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"href":_vm.url,"target":"_blank","color":"secondary","small":"","outlined":""}},[_c('span',{staticClass:"text-notransform"},[_vm._v("Pricing")])])
}
var staticRenderFns = []

export { render, staticRenderFns }